<template>
  <div id="app">
    <!-- <tabbar v-if="!$route.query.Secret" :deviceNo="$route.query.deviceNo" :textColor="tabTextColor">
      <template v-slot:right>
        <div v-if="renewal == '/deviceRecharge'" class="deviceRecharge-record black" @click="handleRecharge">充值记录</div>
        <div v-if="renewal == '/mywallet'" class="deviceRecharge-record" @click="walletRecord">充值记录</div>
      </template>
</tabbar> -->
    <router-view />
  </div>
</template>

<script>
export default {
  data() {
    return {
      tabTextColor: "",
      renewal: "",
      anime: null,
    };
  },

  components: {
    // tabbar,
  },

  mounted() {
    
  },
};
</script>
<style lang="scss">
.deviceRecharge-record {
  font-size: 28px;
  font-weight: 400;
  color: #1d83ef;
}

.white {
  color: #fff;
}

.black {
  color: #000;
}

.Renewal {
  font-size: 28px;
  font-weight: 400;
  color: #1d83ef;
}

.recommend-payWay {
  width: 200px;
  height: 40px;
  background: rgba(255, 235, 235, 0);
  border-radius: 8px;
  border: 2px solid #ffaaa3;
  font-weight: 400;
  font-size: 22px;
  color: #ff4f42;
  line-height: 40px;
  text-align: center;
  margin-left: 24px;
}
</style>
